import { useEffect, useState } from "react";

import type { Workflow } from "@nens/rana/api-v1";

import { SmallTileCard } from "@/components/small-tile-card";
import WorkflowFallbackImg from "@/images/workflow-no-image.png";
import { useWorkflowImageQuery } from "@/queries/query-workflow";

interface WorkflowCardProps {
  workflow: Workflow;
  onClick: () => void;
}

export function WorkflowCard({ workflow, onClick }: WorkflowCardProps) {
  const { data: image, isLoading: isImageLoading } = useWorkflowImageQuery(workflow.id);
  const [imageSrc, setImageSrc] = useState<string>();

  useEffect(() => {
    if (!image) {
      setImageSrc(WorkflowFallbackImg);
      return;
    }

    const objectUrl = URL.createObjectURL(image);
    setImageSrc(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [image]);

  return (
    <SmallTileCard
      title={workflow.title}
      description={workflow.subtitle}
      color="brand.analytic"
      imageSrc={imageSrc}
      imageAlt={workflow.title}
      isImageLoading={isImageLoading}
      onClick={onClick}
    />
  );
}
